import { css } from "@emotion/react";

export const sellerPhoneCss = css`
    .seller-phone-number-title {
        margin: 0;
    }
`;
